import {
    GET_CHAT_TAGS_STARTED,
    GET_CHAT_TAGS_SUCCESS,
    GET_CHAT_TAGS_FAILED,
    CREATE_CHAT_TAG_SUCCESS,
    UPDATE_CHAT_TAG_SUCCESS,
    DELETE_CHAT_TAG_SUCCESS,
    REORDER_CHAT_TAGS_SUCCESS,
} from "./chatTagConstants";

const initialState = {
    chatTags: [],
    isLoading: false,
    error: null,
};

const chatTagReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CHAT_TAGS_STARTED:
            return {
                ...state,
                isLoading: true,
                error: null,
            };

        case GET_CHAT_TAGS_SUCCESS:
            return {
                ...state,
                chatTags: action.payload.chatTags,
                isLoading: false,
                error: null,
            };

        case GET_CHAT_TAGS_FAILED:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error,
            };

        case CREATE_CHAT_TAG_SUCCESS:
            return {
                ...state,
                chatTags: [...state.chatTags, action.payload.chatTag],
            };

        case UPDATE_CHAT_TAG_SUCCESS:
            return {
                ...state,
                chatTags: state.chatTags.map((tag) =>
                    tag.id === action.payload.chatTag.id ? action.payload.chatTag : tag
                ),
            };

        case DELETE_CHAT_TAG_SUCCESS:
            return {
                ...state,
                chatTags: state.chatTags.filter((tag) => tag.id !== action.payload.id),
            };

        case REORDER_CHAT_TAGS_SUCCESS:
            // Update the sort_order for each tag based on the reordered array
            const reorderedTags = action.payload.tags;
            return {
                ...state,
                chatTags: state.chatTags.map((tag) => {
                    const reordered = reorderedTags.find((t) => t.id === tag.id);
                    return reordered ? { ...tag, sort_order: reordered.sort_order } : tag;
                }).sort((a, b) => a.sort_order - b.sort_order),
            };

        default:
            return state;
    }
};

export default chatTagReducer;
